<template>
	<div
		class="date-input"
		:class="{
			'date-input--disabled': disabled,
			'date-input--focused': focused,
			'date-input--error': error,
			'date-input--readonly': readonly,
		}"
	>
		<div class="date-input__wrapper">
			<FormInput
				:class="{
					'primary-input--focused': focused,
					'primary-input--error': error,
				}"
				ref="input"
				v-model="formattedDate"
				:id="id"
				:name="name"
				:label="label"
				:label-option="labelOption"
				:placeholder="placeholder"
				icon="date"
				:required="required"
				:disabled="disabled"
				readonly
				:error="error"
				@input="onInput"
				@focus="onFocus"
				@blur="onBlur"
				@keyup="onKeyup"
				@keydown="onKeydown"
			/>
			<FormInputDatePicker
				v-if="datePickerVisible && !readonly"
				ref="datepicker"
				class="date-input__date-picker"
				:initialSelectedDate="value"
				:min-date="minDate"
				:max-date="maxDate"
				:isDateDisabled="isDateDisabled"
				@change="datePickerChangeHandler"
			/>
		</div>
		<span
			class="form-input__hint | form-input-hint"
			v-if="hint"
			v-html="hint"
		/>
		<span
			class="form-input__error | form-input-error"
			v-if="error && errorMessage"
			v-html="errorMessage"
		/>
		<span
			class="form-input__success | form-input-success"
			v-if="successMessage"
			v-html="successMessage"
		/>
	</div>
</template>

<script>
import { dayjsLocal } from '@/helpers/dayjs'
import FormInput from './FormInput';
import FormInputDatePicker from './FormInputDatePicker';
import { switchDateFormat } from '@/utils/formatDate'

export default {
	components: {
		FormInput,
		FormInputDatePicker,
	},
	props: {
		id: String,
		name: String,
		value: String,
		initialValue: String,
		placeholder: String,
		required: Boolean,
		disabled: Boolean,
		readonly: Boolean,
		label: String,
		labelOption: String,
		icon: String,
		minDate: String,
		maxDate: String,
		isDateDisabled: Function,
		hint: String,
		error: Boolean,
		errorMessage: String,
		success: Boolean,
		successMessage: String,
		showDay: Boolean
	},
	data() {
		return {
			//value: this.initialValue,
			datePickerVisible: false,
			focused: false,
		}
	},
	computed: {
		formattedDate() {
			if (!this.value || !this.showDay) {
				return this.value
			}
			return dayjsLocal(new Date(switchDateFormat(this.value, '-'))).locale(this.language.split('-')[0]).format('ddd DD.MM.YYYY')
		}
	},
	model: {
		prop: 'value',
		event: 'input'
	},
	mounted() {
		this.hideDatePickerBound = this.hideDatePicker.bind(this);
		this.bodyEl = document.querySelector('body');
	},
	methods: {
		initialDate() {
			const today = new Date();
			const day = ('0' + today.getDate()).slice(-2);
			const month = ('0' + (today.getMonth() + 1)).slice(-2);
			const year = today.getFullYear();
			return this.initialValue || `${day}.${month}.${year}`;
		},
		updateDatepicker() {
			if (this.$refs.datepicker) {
				this.$refs.datepicker.update();
			}
		},
		showDatePicker() {
			this.datePickerVisible = true;
			this.bodyEl.addEventListener('click', this.hideDatePickerBound);
		},
		hideDatePicker(e) {
			if (e && (e.target === this.$el || this.$el.contains(e.target))) {
				return;
			}
			this.focused = false;
			this.datePickerVisible = false;
			this.bodyEl.removeEventListener('click', this.hideDatePickerBound);
		},
		datePickerChangeHandler(event) {
			this.hideDatePicker();
			this.onInput(event);
		},
		onInput(event) {
			this.$emit('input', event.value);
		},
		onFocus(e) {
			this.focused = true;
			this.showDatePicker();
			this.$emit('focus', e);
		},
		onBlur(e) {
			// this.focused = false;
			this.$emit('blur', e);
		},
		onKeyup(e) {
			this.updateDatepicker();
			this.$emit('keyup', e);
		},
		onKeydown(e) {
			this.$emit('keydown', e);
		},
	},
}
</script>

<style>

</style>
